/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_Col_ScopeInputs */

const vi_api_keys_col_scope = /** @type {(inputs: Api_Keys_Col_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loại khóa`)
};

/**

* @param {Api_Keys_Col_ScopeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const api_keys_col_scope = /** @type {((inputs?: Api_Keys_Col_ScopeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Col_ScopeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_api_keys_col_scope(inputs)
});